<template>
  <div>

    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Reconocimiento Anual" key="1">
        <a-card title="Filtro por Fecha Creación" size="small">
          <a-form-model :model="filterParams" v-bind="fiOptionsFilter" ref="filterForm">
            <a-row>
              <a-col v-bind="colSpanFilter">
                <a-form-model-item :label="$t('Fecha Desde')" has-feedback
                                   :rules="[{ required: false, message: 'Valor requerido' }]">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD"
                                 v-model="filterParams.fecha_desde_reco_year"/>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpanFilter">
                <a-form-model-item :label="$t('Fecha Hasta')" has-feedback
                                   :rules="[{ required: false, message: 'Valor requerido' }]">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD"
                                 v-model="filterParams.fecha_hasta_reco_year"/>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpanFilter">
                <a-form-model-item :wrapper-col="{ span: 16 }">
                  <a-button type="primary" @click="filtrar">Filtrar</a-button>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-card>
        <!--        <a-card>
                  <a-form-model :model="filterParams" v-bind="fiOptionsFilter" ref="filterForm">
                    <a-row>
                      <a-col v-bind="colSpanFilter">
                        <a-form-model-item :label="$t('Año')" prop="year" has-feedback
                                           :rules="[{ required: false, message: 'Valor requerido' }]">
                          <a-input v-model="filterParams.year">
                          </a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpanFilter">
                        <a-form-model-item :wrapper-col="{ span: 16 }">
                          <a-button type="primary" @click="filtrar">Filtrar</a-button>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </a-form-model>
                </a-card>-->
        <br>
        <g-master :name="master.endpoint"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :parentData="filterParams"
                  :actions="false"
                  @action="masterAction"
                  ref="masterComponent"
        >
          <span slot="estadoRecoRenderer" slot-scope="{text}">
            <a-tag :color="getColor(text)">{{getValueApproval(text)}}</a-tag>
          </span>
          <template slot="expandedRowRender" slot-scope="{text}">
            <template v-for="ve in reconocimiento.valoresExpandidos">
              {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
            </template>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Detalle" key="1">
        <a-card hoverable v-if="id_emp">
          <a-card-meta :title="reconocimientoSeleccionado.id_emp_name">
            <a-avatar
              slot="avatar"
              :src="profileSrc"
            />
          </a-card-meta>
          <a-tag color="blue" v-html="getDescription">
          </a-tag>
        </a-card>
        <reconocimiento-anual-detalle ref="masterAnual" :id_emp="id_emp"
                                      :fecha_desde="filterParams.fecha_desde_reco_year"
                                      :fecha_hasta="filterParams.fecha_hasta_reco_year"
                                      v-if="id_emp"/>
        <span v-else>Dar clic en el detalle <a-icon type="search"/> para ver las calificaciones.</span>
      </a-tab-pane>
    </a-tabs>
    <modal-calificacion-reconocimiento ref="modal" @handleOk="loadData"/>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'

  export default {
    mounted () {
      this.role = this.getRole()
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        reconocimientoSeleccionado: {},
        defaultPicture: require('./../../../assets/anon_profile.png'),
        profileSrc: require('./../../../assets/anon_profile.png'),
        role: null,
        master: {
          valoresExpandidos: [
            {label: 'Cargo', column: 'cargo'},
            {label: 'Compañia', column: 'company_name'},
            {label: 'Grupo', column: 'h_att_1'},
            {label: 'Puesto', column: 'h_att_2'},
            {label: 'Personal', column: 'h_category'},
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          endpoint: 'gestion_humana/reconocimiento',
          tableSetup: {
            customSlots: ['estadoRecoRenderer'],
            actions: {
              actions: [
                {
                  name: 'detalles',
                  text: 'Detalles',
                  icon: 'search',
                  props: {size: 'small', type: 'link', icon: 'search', style: 'color:green;'}
                },
                {
                  name: 'calificar',
                  text: 'Calificar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'check'},
                  fnVisible: (record) => {
                    if (!this.$isEmpty(this.role)) {
                      if (this.$isEmpty(record.status_rec_cali)) {
                        if (!this.$isEmpty(record.roles)) {
                          return !record.roles.split(',').includes(this.role)
                        } else {
                          return true
                        }
                      }
                    } else {
                      return false
                    }
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'id_recognition'
            },
            columns: [
              {title: 'Identificación', dataIndex: 'id_person', sorter: true},
              {title: 'Empleado', dataIndex: 'id_emp_name', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Fecha inicio contrato', dataIndex: 'initial_date', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status_rec_cali',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRecoRenderer'
                }
              }
            ]
          }
        },
        filterParams: {
          recognition_year: true,
          fecha_desde_reco_year: null,
          fecha_hasta_reco_year: null
        },
        fiOptionsFilter: {
          'label-col': {span: 8},
          'wrapper-col': {span: 12}
        },
        colSpanFilter: {
          xs: 16,
          md: 6
        }
      }
    },
    methods: {
      loadData () {
        this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
        this.$refs.masterAnual && this.$refs.masterAnual.loadData()
      },
      masterAction (action) {
        switch (action.action) {
          case 'calificar':
            this.$refs.modal && this.$refs.modal.showModal(
              {
                record: action.record,
                role: this.role
              }
            )
            break
          case 'detalles':
            this.reconocimientoSeleccionado = action.record
            break
        }
      },
      getRole () {
        let rolesAPR = this.$getConfigValue('APR_ROLES', ['APR_HSEQ', 'APR_BIENESTAR', 'APR_OPERACIONES'])
        if (typeof rolesAPR === 'string') {
          rolesAPR = rolesAPR.split(',')
        }
        for (let rol of rolesAPR) {
          if (this.roles.includes(rol)) {
            return rol
          }
        }
      },
      loadEmployPicture () {
        this.profileSrc = this.defaultPicture
        this.httpClient.getInstance().get('picture_service/render/profile/' + this.reconocimientoSeleccionado.id_person, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
      },
      filtrar () {
        if (!this.$isEmpty(this.filterParams.fecha_desde_reco_year) && !this.$isEmpty(this.filterParams.fecha_hasta_reco_year)) {
          this.filterParams = {
            recognition_year: true,
            fecha_desde_reco_year: this.filterParams.fecha_desde_reco_year,
            fecha_hasta_reco_year: this.filterParams.fecha_hasta_reco_year
          }
        } else {
          this.filterParams = {
            recognition_year: true
          }
        }
      },
      getValueApproval (text) {
        switch (text) {
          case null:
          case undefined:
            return ''
          case 'CALIFICADO':
            return 'CALIFICADO'
          case 'RECHAZADO':
            return 'RECHAZADO'
          case 'INCOMPLETO':
            return 'INCOMPLETO'
          case 'SIN_CALIFICAR':
            return 'SIN_CALIFICAR'
        }
      },
      getColor (text) {
        switch (text) {
          case null:
            return 'white'
          case 'CALIFICADO':
            return 'green'
          case 'RECHAZADO':
            return 'red'
          case 'INCOMPLETO':
            return 'blue'
          case 'SIN_CALIFICAR':
            return 'purple'
        }
      }
    },
    computed: {
      getDescription () {
        return `<strong>Identificación:</strong> ${this.reconocimientoSeleccionado.id_person}`
      },
      roles () {
        return this.$store.state.userInfo.roles.map(role => role.name)
      },
      id_emp () {
        return this.reconocimientoSeleccionado.id_emp
      },
      year_emp () {
        return this.reconocimientoSeleccionado.year
      }
    },
    watch: {
      id_emp () {
        this.loadEmployPicture()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/Reconocimiento/ReconocimientoAnual.vue